export default __webpack_public_path__ + "static/media/vivabonito12.ddecd568.jpg";